import { useState, useEffect, useCallback } from 'react';
import ScreenService from '../services/screen-service';

const useShiftState: Function = (): boolean => {
  const [isShiftPressed, setIsShiftPressed]: [boolean, Function] = useState(false);

  const onKeyDown: ReactEventListener = useCallback((event: React.KeyboardEvent): void => {
    setIsShiftPressed(event.shiftKey);
  }, []);

  const onKeyUp: ReactEventListener = useCallback((): void => {
    setIsShiftPressed(false);
  }, []);

  useEffect((): ReactUseEffectCleanUp => {
    ScreenService.addEventListener('keydown', onKeyDown);

    return (): void => {
      ScreenService.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  useEffect((): ReactUseEffectCleanUp => {
    ScreenService.addEventListener('keyup', onKeyUp);

    return (): void => {
      ScreenService.removeEventListener('keyup', onKeyUp);
    };
  }, []);

  return isShiftPressed;
};

export default useShiftState;
